import { useAppState } from 'hooks/useAppState';
import { Cache } from 'types/util';

export const useNewReviewsCount = (): Cache<number> => {
  const { newReviewsCount } = useAppState();

  return newReviewsCount;
};
